export default __webpack_public_path__ + "static/contact_us-21c61f1b4fbd7be474450a9d807f433b.svg";